import translate from "@insite/client-framework/Translate";

const emailRegex = new RegExp("^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$");
const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
const usCaPORegex = /^(\d{5}(-\d{4})?|[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9])$/;
const postalCodeRegex = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;
const zipRegex = /^\d{5}(-\d{4})?$/;
const scriptValidationRegex = /<[^>]*script/;
const twoNonSpacedChar = /(?=\S.*\S)\S*/;
const alphaNumeric = /^[a-zA-Z0-9]+$/;

export const validateCompanyNameField = (company: string, isAccountRequestForm?: boolean) => {
    const errorMessage = !company || company!.length < 2 || !twoNonSpacedChar.test(company) || scriptValidationRegex.test(company) ? translate(isAccountRequestForm ? "Please enter your legal company name." : "Please enter a company name.") : "";
    return errorMessage;
};

export const validateFirstNameField = (name: string, isAccountRequestForm?: boolean) => {
    const errorMessage = !name || name!.length < 2 || name!.length > 60 || !twoNonSpacedChar.test(name) || scriptValidationRegex.test(name) ? translate(isAccountRequestForm ? "Please enter your first name." : "Please enter a first name.") : "";
    return errorMessage;
};

export const validateLastNameField = (name: string, isAccountRequestForm?: boolean) => {
    const errorMessage = !name || name!.length < 2 || name!.length > 60 || !twoNonSpacedChar.test(name) ? translate(isAccountRequestForm ? "Please enter your last name." : "Please enter a last name.") : "";
    return errorMessage;
};

export const validatePhoneField = (phone: string) => {
    const errorMessage =
        !phone || (phone && !phoneRegex.test(phone)) || scriptValidationRegex.test(phone)
            ? translate("Please enter a valid phone number including the area code.")
            : "";
    return errorMessage;
};
export const validateFaxField = (fax: string) => {
    if (!fax || fax?.length === 0) {
        return ""
    }

    const errorMessage =
        !fax || (fax && !phoneRegex.test(fax)) || scriptValidationRegex.test(fax)
            ? translate("Please enter a valid fax number including the area code.")
            : "";
    return errorMessage;
};

export const validateEmailField = (email: string) => {
    const errorMessage =
        !email || (email && !emailRegex.test(email)) || scriptValidationRegex.test(email) ? translate("Please enter a valid email address.") : "";
    return errorMessage;
};

export const validateQuantityField = (qty: string) => {
    const errorMessage = !qty || Number.isNaN(+qty) || +qty < 1 || scriptValidationRegex.test(qty) ? translate("Please enter a quantity.") : "";
    return errorMessage;
};

export const validateAddress1 = (address?: string, isAccountRequestForm?: boolean) => {
    const errorMessage =
        !address || address!.length < 2 || address!.length > 60 || !twoNonSpacedChar.test(address) || scriptValidationRegex.test(address) ? translate(isAccountRequestForm ? "Please enter your address line 1." : "Please enter an address.") : "";
    return errorMessage;
};

export const validateAddress2 = (address?: string, isAccountRequestForm?: boolean) => {
    if (address?.length === 0 || !address) {
        return "";
    }

    const errorMessage =
        address!.length < 2 || address!.length > 60 || scriptValidationRegex.test(address) ? translate(isAccountRequestForm ? "Please enter your address line 2." : "Please enter an address.") : "";
    return errorMessage;
};

export const validateCountry = (country?: string) => {
    const errorMessage = !country || scriptValidationRegex.test(country) ? translate("Please select a country.") : "";
    return errorMessage;
};

export const validateState = (state?: string, isAccountRequestForm?: boolean) => {
    const errorMessage = !state || scriptValidationRegex.test(state) ? translate(isAccountRequestForm ? "Please make a selection." : "Please select a state / province.") : "";
    return errorMessage;
};

export const validateStateName = (state?: string, isAccountRequestForm?: boolean) => {
    const errorMessage = !state || state!.length < 2 || scriptValidationRegex.test(state) ? translate(isAccountRequestForm ? "Please enter a state / province." : "Please enter a state / province.") : "";
    return errorMessage;
};

export const validateCity = (city?: string) => {
    const errorMessage = !city || city!.length < 2 || city!.length > 60 || !twoNonSpacedChar.test(city) || scriptValidationRegex.test(city) ? translate("Please enter a city.") : "";
    return errorMessage;
};

export const validatePostalCode = (code?: string, country?: string, isAccountRequestForm?: boolean) => {
    if (country) {
        if (country === "US") {
            const errorMessage = !code || (code && !zipRegex.test(code)) || scriptValidationRegex.test(code) ? translate(isAccountRequestForm ? "Please enter a valid zip code." : "Please enter a zip code.") : "";
            return errorMessage;
        }
        if (country === "CA") {
            const errorMessage =
                !code || (code && !postalCodeRegex.test(code)) || scriptValidationRegex.test(code) ? translate(isAccountRequestForm ? "Please enter a valid postal code." : "Please enter a postal code.") : "";
            return errorMessage;
        }
    }
    const errorMessage =
        !code || (code && !usCaPORegex.test(code)) || scriptValidationRegex.test(code) ? translate(isAccountRequestForm ? "Please enter a valid Zip/Postal Code." : "Please enter a zip / postal code.") : "";
    return errorMessage;
};

export const validateProjectDescription = (message?: string) => {
    const errorMessage =
        !message || message!.length < 10 || scriptValidationRegex.test(message)
            ? translate("Please describe your project here.")
            : "";
    return errorMessage;
};

export const validateSelectedJobTitle = (title?: string) => {
    const errorMessage = !title || scriptValidationRegex.test(title) ? translate("Please make a selection.") : "";
    return errorMessage;
};

export const validateJobTitleField = (title?: string) => {
    const errorMessage = !title || title!.length < 2 || scriptValidationRegex.test(title) ? translate("Please enter your job title.") : "";
    return errorMessage;
};

export const validateSelectedBusinessType = (type?: string) => {
    const errorMessage = !type || scriptValidationRegex.test(type) ? translate("Please make a selection.") : "";
    return errorMessage;
};

export const validateExistingCustomerValue = (value?: string) => {
    const errorMessage = !value || scriptValidationRegex.test(value) ? translate("Please make a selection.") : "";
    return errorMessage;
};

export const validateAccountNumberField = (number?: string) => {
    const errorMessage = !number || number!.length < 2 || !twoNonSpacedChar.test(number) || !alphaNumeric.test(number) || scriptValidationRegex.test(number) ? translate("Please enter your account number.") : "";
    return errorMessage;
};

export const validateTradeOrDbaNameField = (tradeOrDbaName: string) => {
    const errorMessage = !tradeOrDbaName || tradeOrDbaName!.length < 2 || !twoNonSpacedChar.test(tradeOrDbaName) || scriptValidationRegex.test(tradeOrDbaName) ? translate("Please enter your trade/DBA name.") : "";
    return errorMessage;
};